import { NumericFormat, NumericFormatProps } from 'react-number-format';
import Input from './Input';

interface CurrencyInputProps extends Omit<NumericFormatProps, 'onValueChange' | 'customInput' | 'value' | 'onChange'> {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  errMsg?: string;
  tooltipText?: string;
  labelAbove?: boolean;
  textWhite?: boolean;
  additionalClasses?: string;
  alignRight?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  id,
  label,
  value,
  onChange,
  errMsg,
  tooltipText,
  labelAbove,
  textWhite,
  additionalClasses,
  alignRight,
  disabled,
  ...rest
}) => (
  <div className='relative w-full'>
    <div className={`absolute left-3 ${labelAbove ? 'top-[41px]' : 'top-[13px]'} font-medium z-10`}>$</div>
    <NumericFormat
      id={id}
      value={value}
      thousandSeparator="."
      decimalSeparator=","
      allowNegative={false}
      customInput={Input}
      placeholder={' '}
      style={{ paddingLeft: '24px' }}
      onValueChange={({ floatValue }) => {
        onChange(floatValue ?? 0);
      }}
      label={label}
      errMsg={errMsg}
      tooltipText={tooltipText}
      labelAbove={labelAbove}
      textWhite={textWhite}
      additionalClasses={additionalClasses}
      alignRight={alignRight}
      disabled={disabled}
      {...rest}
    />
  </div >
);

export default CurrencyInput;
